import * as React from 'react';
import {useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import Top from "../Top";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import {styled} from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import {FormContainer, PasswordElement, PasswordRepeatElement, TextFieldElement} from "react-hook-form-mui";

import HttpsIcon from '@mui/icons-material/Https';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import api from "../../utils/api";
import * as util from "../../utils/util";
import { parseNiceAuthData } from "../../utils/niceAuth";

const typeSaveBasicParam = { id: '', companyId: '', userName: '', birthDate: '', cusId: '', phone: '', address: '', buildingNum: ''
  ,email: '', zipCode: '', beforePassword: '', afterPassword: '', afterPasswordCheck: '' };

const UserJoin = () => {
  const navigate = useNavigate();
  const [isEmailCheck, setIsEmailCheck] = React.useState(false);
  const [userId, setUserId] = React.useState('');
  const [saveBasicParam, setSaveBasicParam] = React.useState(typeSaveBasicParam);
  const location = useLocation();
  
  useEffect(() => {
    // 본인인증 결과 해석 — 실패하면 여기서 멈춘다.
    // 예전에는 atob 가 예외를 던져 가입 화면이 흰 화면이 되거나,
    // data 가 없을 때 이름·생년월일이 문자열 "undefined" 인 채로 다음 단계까지 갔다.
    // 판정 규칙과 근거는 utils/niceAuth.ts 참고.
    const locationSearch = new URLSearchParams(location.search);
    const authResult = parseNiceAuthData(locationSearch.get('data'));

    if (authResult === null) {
      alert('본인인증 정보를 확인하지 못했습니다.\n처음부터 다시 진행해 주세요.');
      // replace — 뒤로가기로 이 빈 콜백 주소에 다시 들어오지 않게 한다
      navigate('/Join/Join', { replace: true });
      return;
    }

    setSaveBasicParam((prev) => ({
      ...prev,
      userName: authResult.userName,
      birthDate: authResult.birthDate,  // YYYYMMDD
    }));
  }, []);
  
  // 회원 추가정보를 받기 위한 화면으로 이동
  async function handleSaveUser(data :any){
    if(!isEmailCheck){
      alert('아이디 중복확인을 해주세요.');
    }else{
      data.password = data.afterPassword;
      data.companyId = 'DUALHEALTH';  // 개인회원 가입 시, 입력 값
      data.name = saveBasicParam.userName;
      data.birthDate = saveBasicParam.birthDate;
      
      navigate('/Join/UserJoinPrivate', {state: data});
    }
  }

  

  return (
    <Container sx={Logbg}>
      <Top title="회원 가입" />

      <Stack direction={'column'} sx={{ justifyContent: 'center', alignContent: 'center' }}>
        <FormContainer
          values={{id: saveBasicParam.id,
          afterPassword: saveBasicParam.afterPassword, 
          afterPasswordCheck: saveBasicParam.afterPasswordCheck}}
          onSuccess={data => handleSaveUser(data)}
        >

          <Card sx={{ p: '20px 20px 30px 20px', bgcolor:'#fff' }}>
            <Divider sx={{fontSize:18, mb:2, fontWeight:700}}>계정 정보</Divider>

            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <AccountCircleIcon sx={profileIcon} />
              <TextFieldElement
                name="id"
                id="id" label="아이디" variant="standard"
                fullWidth
                rules={{
                  required: '아이디 필수 입력입니다.',
                }}
                
                onChange={(e :any) => {
                  setSaveBasicParam((prev) => true ? {...prev, id: e.target.value} : prev);
                  setUserId(e.target.value);
                }}
                sx={loginField}
                inputProps={{ readOnly: isEmailCheck }}
              />
              <Button onClick={() => {
                if(util.strNull(userId) !== ''){
                  const idType = /^[a-z0-9+]*$/;
                  if(idType.test(userId)){
                    api.get('permission/customers/check', { params : {email: userId} }).then(res => {
                      setIsEmailCheck(res.data.success);
                      if(!res.data.success){
                        alert('이미 사용중이거나 사용할 수 없는 아이디입니다.');
                      }else{
                        alert('사용 가능한 아이디입니다.');
                      }
                    }).catch(function (error) {
                      console.log(error);
                    });
                  }else{
                    alert('아이디는 영문(소문자)+숫자만 사용 가능합니다.');
                  }
                }else{
                  alert('아이디 입력 후 시도해주세요.');
                }
              }} sx={{ fontSize: 14, minWidth: 70, border: '1px solid #ed6c02', borderRadius: 20, color: '#ed6c02', bgcolor: '#ed6c0214', fontWeight: 700, p: .5 }}>
                중복확인
              </Button>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
              <HttpsIcon sx={profileIcon} />
              <PasswordElement fullWidth id="input-new" label="비밀번호" variant="standard" type={'password'} name="afterPassword"
                rules={{
                  required: '필수 입력입니다.',
                  pattern: {
                    value: /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,15}$/i,
                    message: saveBasicParam.afterPassword.length > 15 ? '비밀번호는 8자리 이상 15자리 이하로 입력해주세요.' : '영문자+숫자+특수문자 조합 8자리 이상 필수',
                  },
                }}
                onChange={(e :any) => {
                  setSaveBasicParam((prev) => true ? {...prev, afterPassword: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
              <HttpsIcon sx={profileIcon} />
              <PasswordRepeatElement passwordFieldName={'afterPassword'} name="afterPasswordCheck" fullWidth id="input-confirm"
                label="비밀번호 확인" variant="standard" type={'password'}
                rules={{
                  required: '필수 입력입니다.',
                }}
                onChange={(e :any) => {
                  setSaveBasicParam((prev) => true ? {...prev, afterPasswordCheck: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>
      
          </Card>

          <Box sx={{ p: '10px 0px 30px 0px' }}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 3, bgcolor: '#ffb068', borderRadius: '20px' }}>
              <CareButton variant="contained" type={'submit'}>
                다음
              </CareButton>
            </Stack>
          </Box>
        </FormContainer>

      </Stack>
      
    </Container>

  );
}

const profileIcon = {
  color: '#888', mr: 1, my: 0.5, fontSize: 20
}

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '100%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const loginField = {
  '& input': {
    fontSize: 16
  },
  '& label': {
    color: '#888',
    fontSize: 16
  },
  '& label.Mui-focused': {
    color: '#ef8322',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#ef8322',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};

const Logbg = {
  bgcolor: '#f6f6f6',
  height: '100%',
  minHeight: '100vh',
  pb: 4,
  minWidth: '320px',
  pt: 10,
}

export default UserJoin;